export const primatooRevision = "2.2.10-build";
